import { useDelete, useGet, usePost } from "../../common/fetchServices";
import { AUTH_BASE_URL } from "../../props";
import { notBlank } from "../../util/ext";

const getIpOverridesUrl = (filter, limit, offset, order) => {
  const url = `${AUTH_BASE_URL}/regions/overrides?limit=${limit}&offset=${offset}&order=${order}`;
  return notBlank(filter) ? `${url}&filter=${filter}` : url;
};

const getIpOverrideUrl = ({ regionIpOverrideId }) =>
  `${AUTH_BASE_URL}/regions/overrides/${regionIpOverrideId}`;

export const useIpOverrides = (filter, order, page, limit = 9999) => {
  const offset = page * limit;
  const url = getIpOverridesUrl(filter, limit, offset, order);
  return useGet(["ip-overrides", { url }], url);
};

export const useIpOverrideCreate = () => {
  const url = `${AUTH_BASE_URL}/regions/overrides`;
  return usePost(() => url, {
    queriesToInvalidate: [["ip-overrides"]],
  });
};

export const useIpOverrideDelete = () => {
  return useDelete(getIpOverrideUrl, {
    queriesToInvalidate: [["ip-overrides"]],
  });
};

export const useRegions = () => {
  const url = `${AUTH_BASE_URL}/regions`;
  return useGet(["regions"], url);
};
